module.exports = __webpack_public_path__ + "static/media/slider-11.a28bfdee.jpg";